import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoOutputqueuesGetRes } from "./abst/DtoOutputqueuesGetRes";

export class DtoOutputqueuesGetResImple extends DtoOutputqueuesGetRes {
  public url: string = "";

  // public pager = new DtoApiPager();
}
